import React from 'react'
import { Title, BodyWrapper, EmphasisWrapper } from './Thrive.styles'
import { useTranslation } from 'hooks/useTranslation'
import { Text } from 'components/Text'
import { Article } from 'components/Sections/Article'
import Trans from 'next-translate/Trans'
import Link from 'next/link'

export const Thrive: React.FC = () => {
  const { t } = useTranslation()
  const scholarLink =
    'https://www.helsinki.fi/en/researchgroups/dogrisk-health-via-nutrition-epidemiology-and-disease-detection-dogs/research/dogrisk-nutrition-related-research'
  const tryFreezeDriedLink = 'https://try.wefeedraw.com/products-freeze-dried'
  const earInfectLink = 'https://www.frontiersin.org/journals/veterinary-science/articles/10.3389/fvets.2023.1186131/full'
  const skinAllergiesLink = 'https://onlinelibrary.wiley.com/doi/10.1111/jvim.16211'
  const tummyProblemsLink = 'https://www.nature.com/articles/s41598-023-27866-z'
    return (
    <Article background="white">
      <Title id="thrive-title">{t('raw-benefits:thrive.title')}</Title>

      <BodyWrapper>
        <Text>
          <Trans
            i18nKey="raw-benefits:thrive.body.0"
            components={{ RecipeLink: <Link href='/recipes' />, FreezeDriedLink: <Link href={tryFreezeDriedLink} /> }}
          />
          </Text>
        <Text>
          <Trans
            i18nKey="raw-benefits:thrive.body.1"
            components={{ EarInfectionLink: <Link href={earInfectLink} />, SkinAllergiesLink: <Link href={skinAllergiesLink} />, TummyProblemsLink: <Link href={tummyProblemsLink} /> }}
          />
        </Text>
        <Text>
          <Trans
            i18nKey="raw-benefits:thrive.body.2"
            components={{ Link: <Link href={scholarLink} /> }}
          />
        </Text>
      </BodyWrapper>

      <EmphasisWrapper>
        <Text weight="bold">{t('raw-benefits:thrive.subtitle')}</Text>
      </EmphasisWrapper>
    </Article>
  )
}
